import React from 'react'
import { withRouter } from 'react-router'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import CustomAppBar from './appBar'
import { connect } from 'react-redux'

const drawerWidth = 280

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    marginTop: theme.spacing(8),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}))

function Menu(props) {
  const { children } = props
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <CssBaseline />
      <CustomAppBar />
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: true,
        })}
      >
        <div className={classes.drawerHeader} />
        { children }
      </main>
    </div>
  )
}

const mapStateToProps = state => ({
  loading: state.loader.loading,
  session: state.session,
})

export default connect(
  mapStateToProps,
  null,
)(withRouter(Menu))